<template>
  <div class="login">
    <div class="login-Container">
      <h1 class="login-Container-Title">{{ $t('lang.login.LoginTitle') }}</h1>
      <div class="login-Container-Con">
        <div style="display: flex">
          <div class="login-Tetx">{{ $t('lang.login.userDisplay') }}</div>
          <div class="laguages">
            <el-dropdown trigger="click" style="margin-left:20px;" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ LanguageValue.label }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div v-for="(item, index) in LanguageList" :key="index">
                  <el-dropdown-item :command="item">{{ item.label }}</el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

        </div>
        <!-- <p class="login-Tetx">{{$t('lang.login.userDisplay')}}</p> -->
        <el-input class="login-input" prefix-icon="icon-yonghu" v-model="admin.username"
          :placeholder="$t('lang.login.user_isloggedin')">
        </el-input>
        <el-input class="login-input" prefix-icon="icon-suo" v-model="admin.password"
          :placeholder="$t('lang.login.Password_By_Supervisor')" type="password"
          @keyup.enter.native="handleLogin"></el-input>
        <el-button type="primary" @click="handleLogin" class="login-Buttom">{{ $t('lang.login.http_login')
        }}</el-button>
        <!-- <p class="login-Forget">
        <span style="margin-right:10px;">忘记密码</span>
        <span style="margin-left:10px;">忘记账号</span></p> -->
        <div style="height:1px;"></div>
      </div>
    </div>
    <div class="ball-one"></div>
    <div class="ball-tow"></div>
    <div class="login-copyright">
      <p>
        Copyright @ 2019-{{ new Date().getFullYear() }} SZCHILINK. All Rights Reserved 深圳市智联物联科技有限公司 版权所有
        <a href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备16125435号</a>
      </p>
      <a href="https://xyt.xcc.cn/getpcInfo?sn=1537335439185117184&language=CN&certType=8&url=*.singleyun.com"
        v-if="$i18n.locale == 'zh-CN'" target="_blank"
        style="position: relative;display: inline-block;height: 38px;margin-left: 10px;">
        <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
        <embed src="https://program.xinchacha.com/web/1537335439185117184=*.singleyun.com.svg" width="103" height="38"
          type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/" />
      </a>
      <a v-else href="https://xyt.xcc.cn/getpcInfo?sn=1537335439185117184&language=EN&certType=8&url=*.singleyun.com"
        target="_blank" style="position: relative;display: inline-block;height: 38px;margin-left: 10px;">
        <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div><embed
          src="https://program.xinchacha.com/web/1537335439185117184=*.singleyun.comen.svg" width="103" height="38"
          type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/" />
      </a>
    </div>
    <div class="version">V2.20260615</div>
  </div>
</template>

<script>
import { SetLan, GetLan } from '@/localStorage/localStorage'
import {
  setuser_id,
  setroleId,
  setuser_ctid,
  setuser_iscustomer
} from "@/localStorage/localStorage";
import { setToken, getToken, setPermission } from "@/cookie/cookie";
import { loginByUsername, showFunctionList, emailLogin } from "@/api/login";

export default {
  data() {
    return {
      admin: {
        username: "",
        password: ""
      },
      //语言列表
      LanguageList: [
        { label: "繁體中文", value: "zh-TW" },
        { label: "简体中文", value: "zh-CN" },
        { label: "English", value: "en-US" },
      ],
      LanguageValue: {
        label: GetLan() == null || (() => { if (GetLan() == 'zh-TW') { return '繁體中文' } else if (GetLan() == 'zh-CN') { return '简体中文' } else { return 'English' } })(),
        value: GetLan()
      },
    };
  },
  methods: {
    //消息提示
    open4() {
      this.$message.error(this.$t('lang.login.password_short'));
      return false
    },
    //切换语言
    handleCommand(command) {
      SetLan(command.value)
      location.reload()
    },
    //登录
    handleLogin() {
      const Email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (this.admin.username == "") {
        this.open4()
        return;
      }
      if (this.admin.password.length < 6) {
        this.open4()
        return;
      }
      //如果当前账户正则匹配到邮箱，使用邮箱登录
      if (Email.test(this.admin.username)) {
        emailLogin(this.admin.username, this.admin.password).then(res => {
          if (res.data.code === 0) {
            if (res.data.token) {
              this.getUserToken(res.data.token)
              //存储用户id
              setuser_id(res.data.user_id)
              //存储角色id
              setroleId(res.data.roleId)
              //存储客户id
              setuser_ctid(res.data.user_ctid)
              //存储唯一标识
              setuser_iscustomer(res.data.user_iscustomer)
              //获取用户权限
              showFunctionList().then(res => {
                if (res.data.code == 0) {
                  setPermission(res.data)
                }
                this.$router.push("dashboard")
              })
            }
          } else {
            this.open4();
          }
        });
      }
      //没有匹配到邮箱，正常账号密码登录
      else {
        loginByUsername(this.admin.username, this.admin.password, GetLan()).then(res => {
          if (res.data.code === 0) {
            if (res.data.token) {
              this.getUserToken(res.data.token)
              //存储用户id
              setuser_id(res.data.user_id)
              //存储角色id
              setroleId(res.data.roleId)
              //存储客户id
              setuser_ctid(res.data.user_ctid)
              //存储唯一标识
              setuser_iscustomer(res.data.user_iscustomer)
              //获取用户权限
              showFunctionList().then(res => {
                if (res.data.code == 0) {
                  setPermission(res.data)
                }
                this.$router.push("dashboard")
              })
            }
          } else {
            this.$message.error(res.data.error_message);
          }
        });
      }
    },
    //存储token保存在cookie
    getUserToken(token) {
      setToken(token)
    }
  }
};
</script>

<style scoped>
.login {
  width: 100%;
  height: 100vh;
  background: url("../../assets/zlwl-min.jpg") no-repeat;
  background-size: 100% 100%;
}

.login-Container {
  width: 400px;
  height: 50vh;
  padding-top: 8%;
  position: relative;
  margin-right: 10%;
  z-index: 2;
  float: right;
}

.login-Container-Title {
  font-size: 35px;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  margin-bottom: 5%;
}

.login-Container-Con {
  width: 100%;
  background-color: #ffffff;
}

.login-Tetx {
  color: #02AEff;
  margin-left: 6%;
  padding-top: 8.1%;
  font-size: 20px;
  font-weight: bold;
}

.laguages {
  color: #02AEff;
  margin-left: auto;
  padding-top: 8.1%;
  padding-right: 10%;
  font-size: 20px;
  font-weight: bold;
  align-self: flex-end;
}

.login-input {
  width: 88%;
  margin: 7% auto;
  display: block;
}

.login-Buttom {
  width: 88%;
  margin: 7% auto 5% auto;
  display: block;
}

.login-copyright {
  width: 100%;
  text-align: center;
  color: #000000;
  font-size: 14px;
  clear: both;
  display: flex;
  margin: 0px auto;
  position: absolute;
  bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ball-one {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #ffffff;
  position: absolute;
  animation: straightLine 5s infinite linear;
  z-index: 1;
  bottom: 0vh;
}

.ball-tow {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #ffffff;
  position: absolute;
  animation: straightLineTow 5s infinite linear;
  z-index: 1;
  bottom: 40vh;
}

@keyframes straightLine {
  5% {
    transform: translate3D(5vw, -10vh, 10vh);
  }

  10% {
    transform: translate3D(10vw, -20vh, 10vh);
  }

  20% {
    transform: translate3D(11vw, -22vh, 20vh);
  }

  30% {
    transform: translate3D(20vw, -12vh, 30vh);
  }

  40% {
    transform: translate3D(30vw, -18vh, 40vh);
  }

  50% {
    transform: translate3D(40vw, -20vh, 40vh);
  }

  60% {
    transform: translate3D(46vw, -13vh, 40vh);
  }

  70% {
    transform: translate3D(55vw, -24vh, 40vh);
  }

  80% {
    transform: translate3D(60vw, -21vh, 50vh);
  }

  90% {
    transform: translate3D(65vw, -24vh, 50vh);
  }

  100% {
    transform: translate3D(100vw, -20vh, 60vh);
  }
}

@keyframes straightLineTow {
  10% {
    transform: translate3D(5vw, -9vh, 10vh);
  }

  20% {
    transform: translate3D(15vw, -13vh, 20vh);
  }

  30% {
    transform: translate3D(18vw, 1vh, 30vh);
  }

  40% {
    transform: translate3D(44vw, -5vh, 40vh);
  }

  50% {
    transform: translate3D(57vw, -1vh, 50vh);
  }

  60% {
    transform: translate3D(60vw, -3vh, 40vh);
  }

  70% {
    transform: translate3D(70vw, -5vh, 40vh);
  }

  80% {
    transform: translate3D(80vw, -8vh, 50vh);
  }

  90% {
    transform: translate3D(90vw, -10vh, 50vh);
  }

  100% {
    transform: translate3D(100vw, -11vh, 60vh);
  }
}

.version {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateY(-50%);
  color: #000;
}
</style>
